import xlsx from "xlsx";
function buildSpreadSheet(data, type) {
  const wb = xlsx.read(data, { type: type });
  console.log(wb);
  async function getSheets() {
    return wb.SheetNames;
  }
  /**
   *
   * @param {} sheetName
   * @returns {Array}
   */
  async function getRowsFromSheet(sheetName) {
    // wb.SheetNames.forEach(function(sheetName) {
    // console.log("Sheet", sheetName);
    var roa = xlsx.utils.sheet_to_json(wb.Sheets[sheetName]);
    // if (roa.length) result[sheetName] = roa;
    // });
    // console.log(JSON.parse(JSON.stringify(result)));
    // return JSON.stringify(result, 2, 2);
    return roa;
  }
  async function getKeysFromSheet(sheetname) {
    const rows = await getRowsFromSheet(sheetname);
    const obj = Object.keys(rows[0] || {});
    return obj;
  }
  return Object.freeze({
    getSheets,
    getRowsFromSheet,
    getKeysFromSheet
  });
}
export default buildSpreadSheet;
